export default {
	// Space creation and access
	createSpace({dispatch}, data) {
		return dispatch('request', {
			url: `/area-management/area`,
			method: 'post',
			data
		})
	},
	adminOfferSpaceAccess({dispatch}, data) {
		return dispatch('request', {
			url: `/area-management/invites/invite-users`,
			method: 'post',
			data
		})
	},
	adminCancelOfferSpaceAccess({dispatch}, token) {
		return dispatch('request', {
			url: `/area-management/invites/cancel/${token}`,
			method: 'post'
		})
	},
	getInviteData({dispatch}, token) {
		return dispatch('request', {
			url: `/area-management/invites/token/${token}`,
			method: 'get'
		})
	},
	getSpaceData({dispatch}, areaId) {
		return dispatch('request', {
			url: `/area-management/area?areaId=${areaId}`,
			method: 'get'
		})
	},
	getPendingInvites({dispatch}) {
		return dispatch('request', {
			url: `/area-management/invites/pending`,
			method: 'get'
		})
	},
	acceptSpaceAccess({dispatch}, token) {
		return dispatch('request', {
			url: `/area-management/invites/accept/${token}`,
			method: 'post'
		})
	},
	rejectSpaceAccess({dispatch}, token) {
		return dispatch('request', {
			url: `/area-management/invites/reject/${token}`,
			method: 'post'
		})
	},
	yieldSpaceAccess({dispatch}, id) {
		return dispatch('request', {
			url: `/area-management/area/leave`,
			method: 'put',
			params: { areaId: id }
		})
	},
}
